export default __webpack_public_path__ + "static/media/AutoNation.d31449dc.svg";